"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventOccurence;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../../../../components/Link/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-informnewsletter-occurence {\n  padding-top: 42px; }\n  .sia-informnewsletter-occurence .sia-informnewsletter-occurence-title {\n    font-size: 26px;\n    line-height: 32px;\n    margin: 0;\n    font-family: 'Helvetica Neue LT Roman'; }\n  .sia-informnewsletter-occurence .sia-informnewsletter-occurence-image img {\n    width: 100%;\n    height: 364px;\n    display: block;\n    object-fit: cover; }\n  .sia-informnewsletter-occurence .sia-informnewsletter-occurence-lead {\n    font-size: 16px;\n    line-height: 22px;\n    color: #000000; }\n";
  const fileName = "EventOccurence_EventOccurence";
  const element = document.querySelector("style[data-sass-component='EventOccurence_EventOccurence']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function EventOccurence(_ref) {
  let {
    lang,
    occurence,
    event_labels,
    optional_title,
    optional_lead
  } = _ref;
  const EVENT_URL = occurence?.evenito_link?.original_url;
  const OCCURENECE_TITLE = occurence?.occurrence_event_code?.title;
  const OCCURENECE_IMAGE_URL = occurence?.occurrence_event_code?.pictures_gallery?.[0]?.[0]?.original?.url;
  const NEWSLETTER_TEXT = occurence?.occurrence_event_code?.newsletter_text;
  const OCCURENECE_DATE = occurence?.date_times?.[0]?.date;
  const OCCURENECE_CITY = occurence?.date_times?.[0]?.event_location?.[0]?.city || '';
  const OCCURENECE_URL_TITLE = `${OCCURENECE_DATE}${OCCURENECE_CITY && ', ' + OCCURENECE_CITY}, ${OCCURENECE_TITLE}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-informnewsletter-occurence"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "sia-informnewsletter-occurence-title"
  }, optional_title, OCCURENECE_TITLE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, optional_title && /*#__PURE__*/_react.default.createElement("br", null), OCCURENECE_TITLE)), OCCURENECE_IMAGE_URL && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-informnewsletter-occurence-image sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: OCCURENECE_IMAGE_URL
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-padding-03-top"
  }, event_labels['cms.inform_newletter.salutation']), optional_lead && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-informnewsletter-occurence-lead sia-padding-02-top",
    dangerouslySetInnerHTML: {
      __html: optional_lead
    }
  }), NEWSLETTER_TEXT && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-informnewsletter-occurence-lead sia-padding-02-top",
    dangerouslySetInnerHTML: {
      __html: NEWSLETTER_TEXT
    }
  }), EVENT_URL && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-top"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
    withLeadIcon: true,
    target: EVENT_URL
  }, OCCURENECE_URL_TITLE))));
}